import React from 'react';
import { AlgoliaProductHit } from '@jbhi-fi/apis/src/algolia/types/AlgoliaProductHit';
import { ProductCard } from '../ProductCard';
import { AlgoliaHitTransformer } from '../Algolia/transformers/AlgoliaHitTransformer';
import { TrackingDescriptorType } from '../Tracking/types';
import { useCustomerContext } from '../context/CustomerContextProvider';
import { useProductCompare } from '../ProductCompare';
import { styles } from './ProductSuggestionsContainer.css';
import { getStoreCurrency } from '@jbhi-fi/utils/src/shopify/getStoreCurrency';
import { useTrackingContext } from '../Tracking';

export type ProductSuggestionsContainerProps = {
  isLoggedIn?: boolean;
  tileVariant: 'fullWidth' | 'minified';
  suggestions: Array<AlgoliaProductHit>;
  onAddToCart: (
    event: React.SyntheticEvent,
    hit: AlgoliaProductHit,
    variantId?: number,
    trackingDescriptor?: TrackingDescriptorType
  ) => Promise<boolean>;
  type: 'alternatives' | 'frequentlyBoughtTogether' | 'recommendedForYou';
};

export const ProductSuggestionsContainer = ({
  tileVariant = 'minified',
  suggestions,
  onAddToCart,
  type,
}: ProductSuggestionsContainerProps) => {
  const { shouldShowCompare, addItemToCompare, isAddedToCompare } = useProductCompare();
  const { isLoggedIn, handleUpdateWishlist, getIsInWishlist } = useCustomerContext();
  const { tracker } = useTrackingContext();

  const wishlistProps =
    tileVariant !== 'minified'
      ? {
          isLoggedIn,
          onUpdateWishlist: handleUpdateWishlist,
          getIsInWishlist,
        }
      : {};

  const compareProps =
    tileVariant !== 'minified'
      ? {
          getShouldShowCompare: shouldShowCompare,
          onCompare: addItemToCompare,
          getIsCompared: isAddedToCompare,
        }
      : {};

  return (
    <div className={styles.container}>
      {suggestions.map(alternative => {
        return (
          <ProductCard
            variant={tileVariant}
            {...AlgoliaHitTransformer.toProductCardProps(alternative, {
              trackingDescriptor: {
                page: tracker.context ?? '',
                group: 'googleRelated',
                category: type,
                currency: getStoreCurrency(),
                ecommerceExtraProps: {
                  list: `${type}-recai`,
                },
              },
            })}
            shouldHideWishlist={tileVariant === 'minified'}
            shouldHideCartOverlay
            shouldHideNotifyMe
            shouldRemainInAddedState
            key={alternative.objectID}
            onAddToCart={
              onAddToCart
                ? (e, _sku, variantId, eventData) =>
                    onAddToCart(e, alternative, variantId, eventData?.trackingDescriptor)
                : undefined
            }
            {...wishlistProps}
            {...compareProps}
          />
        );
      })}
    </div>
  );
};
